import { createAsyncThunk } from "@reduxjs/toolkit";

import { type ProgramWorkout } from "@fitness-app/data-models/entities/TrainingProgram";

import { type AsyncThunkCreator } from "../../../index";
import { TRAINEE_ACTIVITIES_REDUCER_NAME } from "../types";

type Common = {
  eventDate: string;
  workoutTemplate: ProgramWorkout;
};

type Payload = (Common & { traineeIds: string[] }) | (Common & { tags: string[]; condition: "hasTag" | "notHasTag" });

type Response = { requestId: string; queued: number; runId: string };

export const batchAddWorkoutToTrainees = createAsyncThunk<Response, Payload, AsyncThunkCreator<string>>(
  `${TRAINEE_ACTIVITIES_REDUCER_NAME}/batchAddWorkoutToTrainees`,
  async (payload, { rejectWithValue, extra: { workoutsApi } }) => {
    if (!workoutsApi) {
      return rejectWithValue("workoutsApi is not configured");
    }

    const response = await workoutsApi.post<Response>("/batch-save-workout-for-trainees", payload);

    return response.data;
  },
);
